export default __webpack_public_path__ + "static/SRI 1110S - Product Specifications & Technical Data-02b01222f777cb7de2c8661d9d5446d5.pdf";